const Footer = () => {
  return (
    <>
      <div className="maps-navs__show-wrapper tablet-true visible">
        <a
          href="https://2gis.onelink.me/nw2S/q7h8k5s4"
          target="_blank"
          rel="noopener noreferrer"
          className="maps-navs__show"
        >
          <span>Посмотреть рекорды на карте</span>
        </a>
      </div>

      <footer className="footer">
        <div className="container">
          <div className="footer-row row">
            <span className="footer-text">
              © 2ГИС, июль 2026
            </span>

            <a
              href="https://law.2gis.ru/privacy/"
              className="footer-text"
              target="_blank"
              rel="noopener noreferrer"
            >
              Политика конфиденциальности
            </a>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
